import { publicUrlFor } from "../../../../globals/constants";
import { neuronMedia } from "../../../../globals/neuron-content";
import { NavLink } from "react-router-dom";

function SectionVideo2() {
  return (
    <div className="section-full sx-video-2-outer sx-atc-fixed" style={{ backgroundImage: `url(${publicUrlFor(neuronMedia.banners.escort)})` }}>
      <div className="container">
        <div className="sx-vodeo-section text-center">
          <div className="sx-video-btn-wrap">
            <NavLink to="/contact-us" className="circle">
              <i className="flaticon-incoming-call" />
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionVideo2;
